import * as React from 'react';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { Announced } from 'office-ui-fabric-react/lib/Announced';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';

/**
 * Since consumers sometimes pass us localized message IDs, and sometimes pass us
 * full messages, we display the localized message if one exists, and otherwise just
 * display the literal string.
 */
const localizedMessageOrSelf = (message: string): string => loc(message) || message;

const InfoBarAnnouncements = (props: { messages: InfoBarMessageViewState[] }) => {
    const [announcedMessages, setAnnouncedMessages] = React.useState<string[]>([]);
    const previousAnnouncementSet = React.useRef<Set<string>>(new Set());

    // Diff the announcements, and if any have changed, update the message
    // in the aria-live region managed by Announced.
    React.useEffect(() => {
        const currentAnnouncements = props.messages.map(message => message.message);
        const newAnnouncements = [];
        for (let message of currentAnnouncements) {
            if (!previousAnnouncementSet.current.has(message)) {
                newAnnouncements.push(message);
            }
        }

        // Don't clear the message if there were no new messages (e.g. we just updated it),
        // but do clear the message if we added / removed a message (so that it will be)
        // re-announced if we the same message back
        if (
            newAnnouncements.length ||
            currentAnnouncements.length !== previousAnnouncementSet.current.size
        ) {
            setAnnouncedMessages(newAnnouncements);
        }

        previousAnnouncementSet.current.clear();
        currentAnnouncements.forEach(announcement => {
            previousAnnouncementSet.current.add(announcement);
        });
    });

    return <Announced message={announcedMessages.map(localizedMessageOrSelf).join(' ')} />;
};

export default observer(InfoBarAnnouncements);
